module.exports = __webpack_public_path__ + "static/media/holiday-party-catering-1.b7750e72.jpg";